var _path, _mask, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuarantorYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5834 4.66659C10.5834 6.64561 8.9791 8.24992 7.00008 8.24992C5.02106 8.24992 3.41675 6.64561 3.41675 4.66659C3.41675 2.68757 5.02106 1.08325 7.00008 1.08325C8.9791 1.08325 10.5834 2.68757 10.5834 4.66659Z",
    fill: "#FFC857",
    stroke: "#BB8D2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_6434_7813",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78909 8.10251L4.08325 13.4167L6.99992 11.6667L9.91659 13.4167L9.21075 8.09668"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78909 8.10251L4.08325 13.4167L6.99992 11.6667L9.91659 13.4167L9.21075 8.09668",
    fill: "#FFC857"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21075 8.59668C9.48689 8.59668 9.71075 8.37282 9.71075 8.09668C9.71075 7.82054 9.48689 7.59668 9.21075 7.59668V8.59668ZM4.78909 7.59668C4.51294 7.59668 4.28909 7.82054 4.28909 8.09668C4.28909 8.37282 4.51294 8.59668 4.78909 8.59668V7.59668ZM9.21075 7.59668H4.78909V8.59668H9.21075V7.59668ZM5.78038 8.23418C5.8531 7.6867 5.46823 7.18394 4.92075 7.11122C4.37327 7.0385 3.87051 7.42337 3.79779 7.97085L5.78038 8.23418ZM4.08325 13.4167L3.09196 13.285C3.0414 13.6657 3.21327 14.0416 3.53421 14.2525C3.85516 14.4633 4.26847 14.4717 4.59775 14.2742L4.08325 13.4167ZM6.99992 11.6667L7.51441 10.8092C7.19773 10.6192 6.80211 10.6192 6.48542 10.8092L6.99992 11.6667ZM9.91659 13.4167L9.40209 14.2742C9.73134 14.4717 10.1446 14.4633 10.4656 14.2525C10.7865 14.0417 10.9584 13.6658 10.9079 13.2852L9.91659 13.4167ZM10.2021 7.96516C10.1294 7.41767 9.62672 7.03273 9.07923 7.10537C8.53174 7.178 8.1468 7.68072 8.21944 8.2282L10.2021 7.96516ZM3.79779 7.97085L3.09196 13.285L5.07455 13.5483L5.78038 8.23418L3.79779 7.97085ZM4.59775 14.2742L7.51441 12.5242L6.48542 10.8092L3.56876 12.5592L4.59775 14.2742ZM6.48542 12.5242L9.40209 14.2742L10.4311 12.5592L7.51441 10.8092L6.48542 12.5242ZM10.9079 13.2852L10.2021 7.96516L8.21944 8.2282L8.92527 13.5482L10.9079 13.2852Z",
    fill: "#BB8D2F",
    mask: "url(#path-2-inside-1_6434_7813)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantorYellow);
export default __webpack_public_path__ + "static/media/guarantor-yellow.1e5e8c230e515592cb064c0dcc0b3d52.svg";
export { ForwardRef as ReactComponent };